/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-24
 */

// Add local dependencies.
import { useSessionAuth } from '../../hooks/useSessionAuth';
import UserMenu from '../navigation/Header/UserMenu';

/**
 * Authentication navigation component that shows user menu when authenticated.
 * Sign In and Sign Up buttons are now handled by MainNavigation.
 * @example
 * return <AuthNavigation />
 * @returns {React.ReactElement} The authentication navigation component.
 */
const AuthNavigation: React.FC = () => {
  const { isAuthenticated } = useSessionAuth();

  // Show authenticated navigation using enhanced UserMenu
  if (isAuthenticated) {
    return <UserMenu />;
  }

  // Return null for unauthenticated users since auth buttons are in MainNavigation
  return null;
};

export default AuthNavigation;
